import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { saveTwilioCampaignProfile } from 'api/admin/businesses/twilioIntegration';
import { SaveTwilioCampaignProfileRequestPayload } from 'types/twilio/campaignProfile';

interface useSaveTwilioCampaignProfilePayload {
  successCallback?: () => void;
}

export const useSaveTwilioCampaignProfile = ({
  successCallback,
}: useSaveTwilioCampaignProfilePayload) => {
  return useMutation<
    unknown,
    AxiosError<{ error: string }>,
    SaveTwilioCampaignProfileRequestPayload
  >({
    mutationFn: async ({ businessId, campaignProfile }) => {
      return saveTwilioCampaignProfile({ businessId, campaignProfile });
    },
    onSuccess: async () => {
      successCallback?.();
      toaster('Campaign profile has been saved', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while saving campaign profile', {
        icon: '❌',
      });
    },
  });
};
